import * as React from "react"
import "./styles/tesimonials.css"
import Layout from "../components/layout/layout";
import Detailed from "../components/testimonials/detailed/detailed";
import Clients from "../components/testimonials/clients/clients";

const TestimonialsPage = () => {
    return (
        <Layout isHomePage={false} pageName={"Testimonials"}>
            <div className={"py-10"}>
                <Clients/>
            </div>
            <Detailed/>
        </Layout>
    )
}

export default TestimonialsPage